// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Unarchive = function Unarchive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.875 3.125V5h16.25V3.125zM1.25 1.25h17.5c.691 0 1.25.559 1.25 1.25v3.125c0 .691-.559 1.25-1.25 1.25H1.25C.559 6.875 0 6.316 0 5.625V2.5c0-.691.559-1.25 1.25-1.25m0 15V8.125h1.875v8.125c0 .344.281.625.625.625h12.5a.627.627 0 0 0 .625-.625V8.125h1.875v8.125c0 1.379-1.121 2.5-2.5 2.5H3.75a2.5 2.5 0 0 1-2.5-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.002 8.262a.76.76 0 0 0-.546.227L6.508 11.49a.714.714 0 0 0 .032 1.036.77.77 0 0 0 1.057-.03l1.652-1.681v4.177c0 .412.344.73.753.73a.74.74 0 0 0 .753-.73v-4.177l1.65 1.679a.77.77 0 0 0 1.057.03.714.714 0 0 0 .03-1.037l-2.944-2.998a.76.76 0 0 0-.546-.227"
  }));
};
